import { userMachineCatalogueActions } from "../../constants/actionTypes";
import { emptyList } from "../../constants/componentConstants";

const INITIAL_STATE = {
  catalogLabsList: emptyList,
  catalogLabsListError: "",
  lab: "",
  vmList: [],
  vmError: "",
  vmAddStatus: false,
  cloudCatalogList: emptyList,
  createCloudLab: "",
  cloudLabList: "",
  cloudLabExtension: "",
  cloudCatalogError: "",
  commonError: "",
  cloudFeedback: "",
  baseTemplateList: {},
  baseTemplateListLoading: false,
  updateBaseTemplateSuccess: "",
  updateBaseTemplateError: "",
  updateBaseTemplateLoading: false,
  extensionPackList: {},
  basePackList: {},
  extensionAndBasepackLoading: false,
  applyLabExtensionSuccess: "",
  applyLabExtensionError: "",
  applyLabExtensionLoading: "",
  userCatalog_template_type: 1,
  exportSku: "",
  exportError: "",
  cloudlab: "",
  cloudLabListLoading: false,
  applyExtension: {
    data: {},
    loading: false,
    success: false
  }
};

const machineCatalog = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case userMachineCatalogueActions.SET_BASE_TEMPLATES_LIST: {
      return {
        ...state,
        baseTemplateList: {
          ...action?.payload?.data,
        },
      };
    }

    case userMachineCatalogueActions.LOADING_BASE_TEMPLATE_LIST: {
      return {
        ...state,
        baseTemplateListLoading: action?.payload,
      };
    }

    case userMachineCatalogueActions.UPDATE_BASE_TEMPLATE_SUCCESS: {
      return {
        ...state,
        updateBaseTemplateSuccess: action?.payload,
        updateBaseTemplateError: "",
      };
    }

    case userMachineCatalogueActions.UPDATE_BASE_TEMPLATE_ERROR: {
      return {
        ...state,
        updateBaseTemplateError: action?.payload,
        updateBaseTemplateSuccess: "",
      };
    }

    case userMachineCatalogueActions.UPDATE_BASE_TEMPLATE_LOADING: {
      return {
        ...state,
        updateBaseTemplateLoading: action?.payload,
      };
    }

    case userMachineCatalogueActions?.SET_EXTENSION_AND_BASE_PACKS_ACTION: {
      return {
        ...state,
        basePackList: action?.payload?.base_packs,
        extensionPackList: action?.payload?.extension_packs,
      };
    }

    case userMachineCatalogueActions?.SET_EXTENSION_AND_BASE_PACKS_LOADING_ACTION: {
      return {
        ...state,
        extensionAndBasepackLoading: action?.payload,
      };
    }

    case userMachineCatalogueActions.APPLY_LAB_EXTENSION_SUCCESS: {
      return {
        ...state,
        applyLabExtension_Success: action?.payload,
        applyLabExtension_Error: "",
      };
    }

    case userMachineCatalogueActions.APPLY_LAB_EXTENSION_ERROR: {
      return {
        ...state,
        applyLabExtension_Error: action?.payload,
        applyLabExtension_Success: "",
      };
    }

    case userMachineCatalogueActions.APPLY_LAB_EXTENSION_LOADING: {
      return {
        ...state,
        applyLabExtension_Loading: action?.payload,
      };
    }

    case userMachineCatalogueActions.SET_SELECTED_TEMPLATE_TYPE: {
      return {
        ...state,
        userCatalog_template_type: action?.payload,
      };
    }

    case userMachineCatalogueActions.SET_CATALOG_LABS_LIST_DATA:
      return {
        ...state,
        catalogLabsList: {
          ...action?.payload?.data,
        },
        catalogLabsListError: "",
        vmAddStatus: false,
      };

    case userMachineCatalogueActions.SET_CATALOG_LABS_LIST_ERROR:
      return {
        ...state,
        catalogLabsList: emptyList,
        catalogLabsListError: action?.payload,
        vmAddStatus: false,
      };

    case userMachineCatalogueActions.LAB_VIEW_SUCCESS:
      return {
        ...state,
        lab: action?.payload?.data,
      };

    case userMachineCatalogueActions.LAB_VIEW_ERROR:
      return {
        ...state,
        catalogLabsList: emptyList,
        catalogLabsListError: action?.payload,
      };

    case userMachineCatalogueActions.CREATE_VM_SUCCESS:
      return {
        ...state,
        vmList: [...state.vmList, action?.payload?.data],
        vmAddStatus: true,
      };

    case userMachineCatalogueActions.SUCCESS_EXPORT_SKU_TENANT_CATALOG:
      return {
        ...state,
        exportSku: action?.payload,
      };

    case userMachineCatalogueActions.CLEAR_EXPORT_SKU_TENANT_CATALOG:
      return {
        ...state,
        exportSku: "",
      };

    case userMachineCatalogueActions.ERROR_EXPORT_SKU_TENANT_CATALOG:
      return {
        ...state,
        exportError: action?.payload,
      };

    case userMachineCatalogueActions.CREATE_VM_ERROR:
      return {
        ...state,
        vmList: [],
        vmError: action?.payload,
        vmAddStatus: false,
      };
    case userMachineCatalogueActions.SET_VM_ADD_STATUS:
      return {
        ...state,
        vmAddStatus: action?.payload,
        vmError: action?.payload,
      };
    case userMachineCatalogueActions.REMOVE_SELECTED_LAB:
      return {};

    case userMachineCatalogueActions.SUCCESS_CLOUD_CATALOG_LIST:
      return { ...state, cloudCatalogList: action?.payload?.data };

    case userMachineCatalogueActions.SUCCESS_CLOUD_LAB_EXTENSION:
      return { ...state, cloudLabExtension: action?.payload?.data };

    case userMachineCatalogueActions.SUCCESS_CREATE_CLOUD_LAB:
      return { ...state, createCloudLab: action?.payload };

    case userMachineCatalogueActions.REQUEST_CLOUD_LAB_LIST:
      return {
        ...state,
        cloudLabListLoading: true,
      };
    case userMachineCatalogueActions.SUCCESS_CLOUD_LAB_LIST:
      return {
        ...state,
        cloudLabList: action?.payload?.data,
        cloudLabListLoading: false,
      };

    case userMachineCatalogueActions.SUCCESS_CREATE_CLOUD_LAB_FEEDBACK:
    case userMachineCatalogueActions.SUCCESS_UPDATE_CLOUD_LAB_FEEDBACK:
      return { ...state, cloudFeedback: action?.payload };

    case userMachineCatalogueActions.ERROR_CLOUD_CATALOG_LIST:
      return { ...state, cloudCatalogError: action?.payload };

    case userMachineCatalogueActions.ERROR_CLOUD_LAB_EXTENSION:
    case userMachineCatalogueActions.ERROR_CREATE_CLOUD_LAB:
    case userMachineCatalogueActions.ERROR_CLOUD_LAB_LIST:
    case userMachineCatalogueActions.ERROR_CREATE_CLOUD_LAB_FEEDBACK:
    case userMachineCatalogueActions.ERROR_UPDATE_CLOUD_LAB_FEEDBACK:
      return { ...state, commonError: action?.payload };

    case userMachineCatalogueActions.SUCCESS_CLOUD_CATALOG:
      return { ...state, cloudLab: action?.payload?.data };

    case userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_ACTION:
      return {
        ...state,
        applyExtension: {
          ...state?.applyExtension,
          loading: true,
          success: false
        },
      };
    case userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_SUCCESS:
      return {
        ...state,
        applyExtension: {
          ...state?.applyExtension,
          data: action?.payload || {},
          loading: false,
          success: true
        },
      };
    case userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_ERROR:
      return {
        ...state,
        applyExtension: {
          ...state?.applyExtension,
          data: {},
          loading: false,
          success: false
        },
      };
    case userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_RESET:
      return {
        ...state,
        applyExtension: INITIAL_STATE.applyExtension
      };

    default:
      return state;
  }
};

export default machineCatalog;
